<template>
	<div class="container">
		<div class=buttons>
			<div class="button" @click="go">已完成支付</div>
			<div class="button active" @click="back">支付遇到问题，重新支付</div>
		</div>
	</div>
</template>

<script>
import Cookies from 'js-cookie'
import request from "../utils/request"
import { Dialog } from "vant"
import { checkUserAgent } from '@/utils/checkUserAgent'
export default {
	name: 'RouterGo',
	data() {
		return {
			
		}
	},
	mixins: [checkUserAgent],
	created() {
		const appId = Cookies.get('appId')
		const openId = Cookies.get('openId')
		console.log({ appId, openId })
	},
	methods: {
		// 去抽奖
		async toLuckDraw() {
			const res = await request({
				url: "/tour-product/agent/querySubAgentListByParentId",
				method: "post",
				params: {
					parentId: '771506072081268736'
				}
			})
			if (res.data.code === 200) {
				let idList = [
					'771506072081268736',
				]
				idList = idList.concat(res.data.data.map(item => {
					return item.adminId
				}))
				const projectList = ['56'] // 抽奖卡片

				const channelId = Cookies.get('cykskid')
				const productId = Cookies.get("productId")
				const phone = this.$route.query.phone
				if (idList.includes(channelId) && projectList.includes(productId)) {
					Dialog.confirm({
						title: "提示",
						message: "是否跳转抽奖页面？",
					})
						.then(() => {
							window.location.href = `${process.env.VUE_APP_LINGHANG_RDSIRECT_URL}?m=${phone}&t=123456`
						})
						.catch(() => {})
				}
			}
		},
		// 返回购卡页面
		back() {
			const mode = Cookies.get('mode')
			const channelid = Cookies.get('cykskid')
			const productId = Cookies.get('productId')
			this.checkUserAgent({
				success: (res) => {
					// 小程序内嵌
          if (res === 'miniprogram') {
						const appId = Cookies.get('appId')
						const openId = Cookies.get('openId')
						this.$router.push(`/home?channelid=${channelid}&productId=${productId}&mode=${mode}&appId=${appId}&openId=${openId}`)
					}
					// 微信打开
          if (res === 'wechat') {
						this.$router.push(`/home?channelid=${channelid}&productId=${productId}&mode=${mode}`)
					}
          // 浏览器打开
          if (res === 'h5') {
						this.$router.push('/cardactive')
					}
				}
			})
		},
		go() {
			this.$router.push('/qrcode')
		}
	}
}
</script>

<style scoped>
	html,body,#app{
		width: 100%;
		height: 100%;
		margin: 0;
	}
	.container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		height: 100%;
		background-color: #FFF;
	}
	.buttons {
		width: calc(100% - 60px);
		height: 216px;
	}
	.button {
		border-radius: 44px;
		width: 100%;
		height: 88px;
		font-size: 32px;
		font-weight: bold;
		line-height: 88px;
		text-align: center;
		color: #FFF;
		background: #00BE59;
	}
	.button.active {
		margin-top: 40px;
		border: 2px solid #00BE59;
		color: #00BE59;
		background: #FFF;
	}
</style>
